const configuredUrl = (process.env.REACT_APP_API_URL || '').trim().replace(/\/+$/, '');

// CRA forwards development requests to the configured backend via setupProxy.js.
// Production builds use the configured origin, or the current origin when unset.
export const API_URL = process.env.NODE_ENV === 'development' ? '' : configuredUrl;
